import service from "./request";

const HTTP = {
  //数据字典
  _get_dicts_data: (param) => {
    return service.get("/config/api/base/v2/dicts", {
      params: param,
    });
  },
  //获取经纬度
  /*_get_point_data: () => {
    return fetchJsonp('https://api.map.baidu.com/location/ip?ak=G0T3IZDatGXYGTaGiUHY2tXUZNQpcDxP&coor=bd09ll').then(function (response) {
      return response.json();
    });
  },*/
  //手机验证码
  _send_code: (param) => {
    return service.post("/user/api/v2/sendCode", param);
  },
  //手机登录
  _phone_login: (params) => {
    return service.post('/user/api/v2/phoneLogin', params);
  },
  //获取用户资料
  _get_user_data: (param) => {
    return service.get("/user/api/v2/getUserInfo", {
      params: param,
    });
  },
  //获取网易账号
  _get_nim_detail: (param) => {
    return service.get("/user/api/im/detail", {
      params: param,
    });
  },
  //获取当前订单
  _god_2_player: (param) => {
    return service.get("/web/api/order/god2player", {
      params: param,
    });
  },
  //获取游戏分类 - 通过总排序
  _get_all_category: (param) => {
    return service.get('/config/api/home/v2/getAllCategory', {
      params: param,
    });
  },
  //获取红人推荐
  _get_god_star: (param) => {
    return service.get("/web/api/userInterest/getGodStar", {
      params: param,
    });
  },
  //一键关注
  _get_all_focus_user: (param) => {
    return service.post("/web/api/userInterest/focusBatch/user", param);
  },
  //获取最新订单消息
  _get_top_message: () => {
    return service.get("/web/api/god/getMessage");
  },
  //人气推荐
  _get_v2_home_recommend: (params) => {
    return service.get("/web/api/god/v2/newHomeRecommend", { params });
  },
  //人气推荐
  _get_home_recommend_for_pc: (params) => {
    return service.get("/recommend/api/god/v2/homeRecommendForPC", { params });
  },
  //首页游戏推荐
  _v2_get_game_recommend: (params) => {
    return service.get("/web/api/god/newGameRecommend", { params });
  },
  //首页游戏推荐
  _get_category_recommend_for_pc: (params) => {
    return service.get("/recommend/api/god/categoryRecommendForPC", { params });
  },
  //获取banner广告位
  _get_home_config: (params) => {
    return service.get('/config/api/home/v2/getHomeConfig', { params });
  },
  //获取派单类型
  _get_order_type: (params) => {
    return service.get("/recommend/api/user/recommend/room/getDispatchType", { params });
  },
  //根据派单类型随机获取推荐房间
  _get_order_random_room: (params) => {
    return service.get("/recommend/api/user/recommend/room/getRandomDispatchRoom", { params });
  },
  //获取直播间
  _get_room_list: (params) => {
    return service.get("/live/api/room/v2/list", { params });
  },
  // 本周巅峰赛
  _get_room_peak_list: (params) => {
    return service.get("/game/api/interactive/v2/pk/hall/room/peakRank/pc", { params });
  },
  // 派对房间积分榜
  _get_room_week_rank: (params) => {
    return service.get("/game/api/interactive/v2/pk/hall/room/weekRank/pc", { params });
  },
  //获取跨房pk
  _get_room_pk_list: (params) => {
    return service.get("/game/api/interactive/v2/pk/hall/list/pc", { params });
  },
  //获取直播间
  _get_room_list_new: (param) => {
    return service.get("/live/api/room/v2/queryAppRoomList", {
      params: param,
    });
  },
  //获取大神资料
  _get_god_detail: (param) => {
    return service.get("/web/api/god/getGodDetailed", {
      params: param,
    });
  },
  //获取大神资料
  _get_god_category_detail: (param) => {
    return service.get("/web/api/god/getGodCategoryDetailed", {
      params: param,
    });
  },
  //创建订单
  _add_order: (param) => {
    const newParam = { ...param, application: "json" };
    return service.post("/web/api/order/add", newParam);
  },
  //改变订单状态
  _modified_order: (param) => {
    return service.get("/web/api/order/modified", {
      params: param,
    });
  },
  //支付状态
  _is_play_back: (param) => {
    return service.get("/pay/api/recharge/callback/isPlayBack", {
      params: param,
    });
  },
  //订单详情
  _get_order_detail: (param) => {
    return service.get("/web/api/order/detail", {
      params: param,
    });
  },
  //用户个人中心资料
  _get_user_center_info: (param) => {
    return service.get("/web/api/v2/godEnter/getUserCenterInfo", {
      params: param,
    });
  },
  //用户个人中心资料v4
  _get_user_center_info_v4: (param) => {
    return service.get("/user/v2/api/info/getUserInfoDetail/v2", {
      params: param,
    });
  },
  //技能中心
  _get_user_center_info_v5: (param) => {
    return service.get("/user/api/skill/getSkillInfoDetail", {
      params: param,
    });
  },
  //修改头像
  _update_god_avatar: (param) => {
    return service.post("/web/api/v2/godEnter/updateGodAvatar", param);
  },
  //修改基础资料
  _update_user_info: (param) => {
    return service.post("/web/api/v2/godEnter/updateUserInfo", param);
  },
  //修改照片墙
  _update_god_wall_pic: (param) => {
    return service.post("/web/api/v2/godEnter/updateGodWallPic", param);
  },
  //下单记录
  _player_order_list: (param) => {
    return service.get("/web/api/order/player/list", {
      params: param,
    });
  },
  //接单记录
  _takes_order_list: (param) => {
    return service.get("/web/api/order/takes", {
      params: param,
    });
  },
  //钻石 金币 明细
  _get_user_wallet_detail: (param) => {
    return service.get("/web/api/wallet/getUserWalletDetail", {
      params: param,
    });
  },
  //钻石 金币 明细 v2
  _v2_get_user_wallet_detail: (param) => {
    return service.get("/user/api/account/wallet/userWalletDetail", {
      params: param,
    });
  },
  //提现明细
  _get_user_wallet: (param) => {
    return service.get("/web/api/wallet/getUserWallet", {
      params: param,
    });
  },
  //礼物明细
  _get_user_gift: (param) => {
    return service.get("/web/api/userbag/getUserGift", {
      params: param,
    });
  },
  //房间管理
  _get_manager_room: (param) => {
    return service.get("/live/api/room/manager/rooms", {
      params: param,
    });
  },
  //房间管理 _v2
  _get_manager_room_v2: (params) => {
    return service.get("/live/api/room/v2/manager/rooms", { params });
  },
  //房间管理
  _modify_room: (param) => {
    return service.post("/live/api/room/modify", param);
  },
  //充值
  _recharge_pay: (params) => {
    return service.get("/pay/api/recharge/pay", { params });
  },
  // 充值中间层
  _recharge_v3_pay: (params) => {
    return service.post("/web/api/pay/h5/sas/v3/code", params);
  },
  // PC 充值改版
  _recharge_v4_pay: (params) => {
    return service.get("/pay/api/h5/recharge/prepare", { params });
  },
  //金币兑换钻石
  _gold_convert_diamond: (param) => {
    return service.post("/web/api/wallet/v2/goldConvertDiamond", param);
  },
  //礼物兑换到钱包
  _batch_discounting: (param) => {
    // return service.post('/web/api/userbag/batchDiscounting', param);
    return service.post("/user/api/glamour/v2/exchangeGlamour", param);
  },
  //礼物可兑换金额
  _get_discountGift: (params) => {
    // return service.get('/web/api/userbag/getDiscountGift', {params});
    return service.get("/user/api/glamour/getDiscountGift", { params });
  },
  //验证手机
  _phone_code_verify: (param) => {
    return service.get("/web/api/v2/godEnter/phoneCodeVerify", {
      params: param,
    });
  },
  //绑定手机号码
  _v2_bind_phone: (param) => {
    return service.post("/web/api/v2/godEnter/bingPhone", param);
  },
  // sy绑定手机号码
  _v2_bind_phone_sy: (param) => {
    return service.post("/user/api/v2/checkPhone", param);
  },
  //真爱榜
  _getLoveRankMesage: (param) => {
    return service.get("/web/api/god/v2/getLoveRankMesage", {
      params: param,
    });
  },
  //手气榜
  _getLuckRankMessage: (param) => {
    return service.get("/web/api/god/getLuckRankMessage", {
      params: param,
    });
  },
  //周星榜单
  _getWeekRankMessage: (param) => {
    return service.get("/web/api/god/getWeekRankMessage", {
      params: param,
    });
  },
  //财富排行榜
  _getWealthRankMessage: (param) => {
    return service.get("/web/api/god/v2/getWealthRankMessage", {
      params: param,
    });
  },
  //魅力排行榜
  _getGlamourRankMessage: (param) => {
    return service.get("/web/api/god/v2/getGlamourRankMessage", {
      params: param,
    });
  },
  //亲密日榜
  _get_intimate_day_rank: (param) => {
    return service.get("/order/api/intimate/dayRank", {
      params: param,
    });
  },
  //亲密周榜
  _get_intimate_week_rank: (param) => {
    return service.get("/order/api/intimate/weekRank", {
      params: param,
    });
  },
  //亲密周榜排行榜 top3
  _get_intimate_last_week_top: (param) => {
    return service.get("/order/api/intimate/lastWeekTop", {
      params: param,
    });
  },
  //玩家维权
  _add_appeal: (param) => {
    const newParam = { ...param, application: "json" };
    return service.post("/web/api/appeal/playAdd", newParam);
  },
  //玩家维权
  _add_appeal_god: (param) => {
    const newParam = { ...param, application: "json" };
    return service.post("/web/api/appeal/godAdd", newParam);
  },
  //8元专区
  _eight_recommend: (param) => {
    return service.get("/web/api/god/eightRecommend", {
      params: param,
    });
  },
  //颜值专区
  _video_recommend: (param) => {
    return service.get("/web/api/god/videoRecommend", {
      params: param,
    });
  },
  //新人专区
  _mew_recommend: (param) => {
    return service.get("/web/api/god/newRecommend", {
      params: param,
    });
  },
  //获取大神8元专区详情
  _get_eight_god_detail: (param) => {
    return service.get("/web/api/god/getEightGodDetailed", {
      params: param,
    });
  },
  //支付吧实名认证
  _v2_openCertify: (params) => {
    return service.get("/web/api/cert/openCertify", { params });
  },
  //查询支付宝实名认证结果
  _v2_openCertifyStatus: (params) => {
    return service.get("/web/api/cert/query", { params });
  },
  //银行卡绑定
  _v2_setWithdrawExtract: (param) => {
    return service.post("/web/api/v2/wallet/setWithdrawExtract", param);
  },
  //获取可申请品类
  _get_may_apply_category: (param) => {
    return service.get("/web/api/godEnter/getMayApplyCategory", {
      params: param,
    });
  },
  //公会提交
  _v2_applySociaty: (param) => {
    return service.post("/web/api/v2/godEnter/applySociaty", param);
  },
  //查询大神8元区品类资料
  _get_eight_god_category_detailed: (param) => {
    return service.get("/web/api/god/getEightGodCategoryDetailed", {
      params: param,
    });
  },
  //获取直播间信息
  _get_room_detail: (param) => {
    return service.get("/live/api/room/v2/detail", {
      params: param,
    });
  },
  //获取直播间信息(无验证)
  _get_room_card_info: (param) => {
    return service.get("/live/api/room/getRoomCardInfo", {
      params: param,
    });
  },
  //获取是否需要密码
  _if_room_password: (param) => {
    return service.get("/live/api/room/ifRoomPassword", {
      params: param,
    });
  },
  //查询用户技能卡片
  _get_user_skill_cards: (param) => {
    return service.get("/live/api/blackTeam/getUserSkillCardList", {
      params: param,
    });
  },
  //查询用户关系位
  _get_user_relation_cards: (param) => {
    return service.get("/order/api/intimateShow/getIntimateUserShow", {
      params: param,
    });
  },
  //设置用户关系位
  _set_user_relation_cards: (param) => {
    return service.get("/order/api/intimateShow/setUserShow", { params: param });
  },
  //更新技能卡
  _save_user_card: (param) => {
    return service.post("/live/api/blackTeam/saveUserSkillCard", param);
  },
  //删除技能卡
  _delete_user_card: (param) => {
    return service.post("/live/api/blackTeam/delUserSkillCard", param);
  },
  //查询开黑分类数据
  _get_black_team_category_list: (param) => {
    return service.get("/live/api/blackTeam/getBlackTeamCategoryList", {
      params: param,
    });
  },
  //查询开黑游戏
  _get_black_team_category_game: (param) => {
    return service.get("/live/api/blackTeam/getBlackTeamCategoryFlattenList", {
      params: param,
    });
  },
  //开黑快速组队品类
  _get_black_fast_all_category: (param) => {
    return service.get("/live/api/blackGame/getAllCategory", {
      params: param,
    });
  },
  //快速组队
  _get_fast_join_room: (param) => {
    return service.get("/live/api/blackGame/getRoom", {
      params: param,
    });
  },
  //开黑房间列表
  _get_black_team_rooms: (param) => {
    return service.get("/live/api/blackTeam/roomList", {
      params: param,
    });
  },
  //创建开黑房间
  _create_my_game_rooms: (param) => {
    return service.post("/live/api/blackTeam/createRoom", param);
  },
  //是否允许创建开黑房间
  _if_create_game_room: (param) => {
    return service.get("/live/api/blackTeam/ifCreateRoom", {
      params: param,
    });
  },
  //获取我的开黑房间
  _get_my_game_rooms: (param) => {
    return service.get("/live/api/blackTeam/getMyRoom", {
      params: param,
    });
  },
  //主持人上报直播新建
  _mixed_channel_create: (param) => {
    return service.get("/live/api/room/mixed/channel/create", {
      params: param,
    });
  },
  //推送游客账号
  _get_anonymous_push: (param) => {
    return service.get("/live/api/anonymous/push", {
      params: param,
    });
  },
  //获取游客账号
  _get_anonymous_pull: (param) => {
    return service.get("/live/api/anonymous/pull", {
      params: param,
    });
  },
  //获取直播间地址
  _get_room_address: (param) => {
    return service.get("/live/api/room/v2/address", {
      params: param,
    });
  },
  //获取魔法表情
  _get_room_magics: (param) => {
    return service.get("/config/api/gift/getMagicList", {
      params: param,
    });
  },
  //获取直播间用户的扩展信息
  _get_room_member: (params) => {
    return service.get("/live/api/room/memberSign", { params })
  },
  // 获取直播间用户的扩展信息
  _get_user_card: (param) => {
    return service.get("/live/api/room/v2/userCard", {
      params: param,
    });
  },
  //获取VIP头像框配置
  _get_solo_vip: (param) => {
    return service.get("/web/api/mic/solo/vip/info", {
      params: param,
    });
  },
  //获取直播间VIP
  _get_room_vips: (param) => {
    return service.get("/live/api/room/v2/vips", {
      params: param,
    });
  },
  //直播间礼物列表
  _get_all_gift_list: (param) => {
    return service.get("/web/api/gift/getAllGiftList", {
      params: param,
    });
  },
  //直播间礼物列表
  _get_all_gift_list_v2: (param) => {
    // return service.get("/web/api/gift/getGiftList", {
    return service.get("/live/api/goods/v2/findRoomGoods", {
      params: param,
    });
  },
  //开黑礼物列表
  _get_all_gift_list_v3: (param) => {
    return service.get("/web/api/gift/getGameGiftList", {
      params: param,
    });
  },
  //我的背包
  _get_my_bag: (param) => {
    return service.get("/web/api/box/v2/getUserBag", {
      params: param,
    });
  },
  //房间榜单
  _room_tops: (param) => {
    return service.get("/live/api/room/v2/tops", {
      params: param,
    });
  },
  //修改房间信息
  _modify_room_ext: (param) => {
    return service.post("/live/api/room/ext/modify", param);
  },
  //直播间派单
  _add_msg_order: (param) => {
    return service.post("/live/api/msg/order", param);
  },
  //获取最新的直播地址
  _add_review: (param) => {
    const newParam = { ...param, application: "json" };
    return service.post("/web/api/review/add", newParam);
  },
  //查询用户品类信息及个人资料信息
  _get_user_category: (param) => {
    return service.get("/web/api/godEnter/getUserCategory", {
      params: param,
    });
  },
  //大神系统消息设置
  _update_message_set: (param) => {
    return service.post("/web/api/godEnter/updateMessageSet", param);
  },
  //设置接单
  _update_aptitude: (param) => {
    return service.post("/web/api/godEnter/updateAptitude", param);
  },
  //更改限时活动
  _update_limit_activity: (param) => {
    return service.post("/web/api/godEnter/updateLimitActivity", param);
  },
  //个人资质列表- 修改
  _v2_get_all_category: (param) => {
    return service.get("/web/api/v2/godEnter/getAllCategory", {
      params: param,
    });
  },
  //大神详情
  _get_new_god_detailed: (param) => {
    return service.get("/user/api/god/v5/getNewGodDetailed", {
      params: param,
    });
  },
  //大神礼物墙
  _get_user_gift_wall: (param) => {
    return service.get("/web/api/god/getUserGiftWall", {
      params: param,
    });
  },
  //大神礼物墙 V2
  _v2_get_user_gift_wall: (param) => {
    return service.get("/web/api/v2/god/getUserGiftWall", {
      params: param,
    });
  },
  //提交8元订单
  _v2_add_eight: (params) => {
    return service.post("/web/api/order/v3/add_eight", params);
  },
  //提交普通订单
  _v2_add_order: (params) => {
    return service.post("/web/api/order/v3/add", params);
  },
  //获取进场特效配置
  _getEffectInfo: (param) => {
    return service.get("/web/api/solo/effect/info", {
      params: param,
    });
  },
  //设置进场特效
  _setEffect: (param) => {
    return service.post("/web/api/solo/effect/set", param);
  },
  //获取聊天气泡配置
  _getBubbleInfo: (param) => {
    return service.get("/web/api/solo/bubble/info", {
      params: param,
    });
  },
  //设置聊天气泡
  _setBubble: (param) => {
    return service.post("/web/api/solo/bubble/set", param);
  },
  //获取头像框配置
  _getMciSoloInfo: (param) => {
    return service.get("/web/api/mic/solo/info", {
      params: param,
    });
  },
  //设置头像框
  _setSoloMic: (param) => {
    return service.post("/web/api/mic/solo/set", param);
  },
  //设置相亲模式进度
  _setDetingState: (param) => {
    return service.post("/live/api/room/cp/status/set", param);
  },
  //上报相亲目标用户
  _addDataingUser: (param) => {
    return service.post("/live/api/room/cp/target/add", param);
  },
  //选择心动对象
  _cp_follow: (param) => {
    return service.post("/live/api/room/cp/follow", param);
  },
  //弹幕发送
  _barrageSend: (param) => {
    //return service.post('/web/api/barrage/send', param);
    return service.post("/web/api/barrage/sendV2", param);
  },
  //发喇叭
  _trumpetSend: (param) => {
    return service.post("/web/api/trumpet/send", param);
  },
  //用户喇叭信息
  _trumpetInfo: (param) => {
    return service.get("/web/api/trumpet/info", {
      params: param,
    });
  },
  //用户进入直播间
  _room_enter: (param) => {
    return service.get("/live/api/room/enter", {
      params: param,
    });
  },
  //新手玫瑰花
  _get_gift_rewards: (param) => {
    return service.get("/web/api/gift/rewards", {
      params: param,
    });
  },
  //大神评论
  _get_user_comment_wall: (param) => {
    return service.get("/web/api/god/getUserCommentWall", {
      params: param,
    });
  },
  //搜索
  _search_all: (param) => {
    return service.get("/searchV2/api/all", {
      params: param,
    });
  },
  //获取所有排行榜数据
  _get_home_book: (param) => {
    return service.get("/user/v2/api/god/getHomeBook", {
      params: param,
    });
  },
  //cp日榜
  _get_cp_top: (param) => {
    return service.get("/live/api/room/cp/top/daliy", {
      params: param,
    });
  },
  //粉丝列表
  _get_my_fans: (param) => {
    return service.get("/user/v2/api/friend/myFans", {
      params: param,
    });
  },
  //关注列表
  _get_my_follow: (param) => {
    return service.get("/user/v2/api/friend/myAttentions", {
      params: param,
    });
  },
  //移除异常关注
  _del_error_follow: (param) => {
    return service.post("/user/v2/api/friend/removeExFriends", param);
  },
  //移除异常粉丝
  _del_error_fans: (param) => {
    return service.post("/user/v2/api/friend/removeExFans", param);
  },
  //推荐列表
  _get_my_recommend: (param) => {
    return service.get("/recommend/api/friend/recommend", {
      params: param,
    });
  },
  //加关注
  _add_follow_user: (param) => {
    return service.post("/web/api/friend/focus/user", param);
  },
  //取消关注
  _cancel_follow_user: (param) => {
    return service.post("/web/api/friend/cancelFocus/user", param);
  },
  //粉丝已读
  _focus_read: (param) => {
    return service.post("/web/api/friend/focus/read", param);
  },
  //关注直播间
  _add_follow_room: (param) => {
    return service.post("/web/api/friend/focus/room", param);
  },
  //取消关注直播间
  _cancel_follow_room: (param) => {
    return service.post("/web/api/friend/cancelFocus/room", param);
  },
  //我关注的直播间
  _get_my_follow_rooms: (param) => {
    return service.get("/web/api/friend/myRoomAttentions", {
      params: param,
    });
  },
  // 我关注的直播间
  _get_my_follow_rooms_new: (param) => {
    return service.get("/live/api/room/queryAppCollectionRoomList", {
      params: param,
    });
  },
  //是否关注过
  _get_is_follow: (param) => {
    return service.get("/user/v2/api/friend/ifFocused", {
      params: param,
    });
  },
  //移除标签
  _remove_tag: (param) => {
    return service.post(
      `/web/api/label/remove?uid=${param.uid}&labelId=${param.labelId}`,
      {
        params: {},
      }
    );
  },
  //添加标签
  _add_tag: (param) => {
    return service.post(
      `/web/api/label/add?uid=${param.uid}&labelId=${param.labelId}`,
      {
        params: {},
      }
    );
  },
  //查询所有可选标签
  _get_tag_list: (param) => {
    return service.get("/web/api/label/list", {
      params: param,
    });
  },
  //买2送1专区
  _full_give_recommend: (param) => {
    return service.get("/web/api/god/fullGiveRecommend", {
      params: param,
    });
  },
  //买2送1 下单
  _add_plus_times: (params) => {
    return service.post("/web/api/order/v3/add_plus_times", params);
  },
  //声鉴报告
  _get_sound_report: (param) => {
    return service.get("/web/api/v2/godEnter/getSoundReport", {
      params: param,
    });
  },
  //房间权限
  _operation_room_role: (param) => {
    return service.post("/live/api/room/v2/operationRoomRole", param);
  },
  //排麦
  _row_microphone: (param) => {
    return service.get("/live/api/room/rowMicrophone", {
      params: param,
    });
  },
  // 服务端下麦
  _post_server_down_microphone: (params) => {
    return service.post("/liveV2/api/room/queue/downMicrophone", params);
  },
  // 服务端禁用麦位
  _post_server_switch_mic: (params) => {
    return service.post("/liveV2/api/room/queue/switchMic", params);
  },
  //如果是买2送一的活动 查询是否有购买资格
  _is_order_plus_limit: (param) => {
    return service.get("/web/api/order/is_order_plus_limit", {
      params: param,
    });
  },
  //设置上推荐位
  _god_recommend_set: (param) => {
    return service.post("/web/api/god/recommend/set", param);
  },
  //大神是否正在服务中
  _god_order_doing: (param) => {
    return service.get("/web/api/god/order/doing", {
      params: param,
    });
  },
  //一键资质上下架
  _god_set_batch: (param) => {
    return service.post("/web/api/godEnter/batchShelf", param);
  },
  //修改房间当前模板
  _modify_room_template: (param) => {
    return service.post("/live/api/room/modifyRoomTemplate", param);
  },
  //查询房间操作列表
  _query_room_operate_log: (param) => {
    return service.post("/live/api/room/queryRoomOperateLog", param);
  },
  //达人榜
  _get_daren_rank_message: (param) => {
    return service.get("/web/api/god/getDarenRankMessage", {
      params: param,
    });
  },
  //关注集合
  _get_focused_ids: (param) => {
    return service.get("/web/api/friend/givenFocusedIds", {
      params: param,
    });
  },
  //聊天室心动值游戏开始/停止
  _change_game_loveGame: (param) => {
    return service.post("/live/api/game/loveGame", param);
  },
  //麦位倒计时/停止
  _change_room_timing: (param) => {
    return service.post("/live/api/room/timing", param);
  },
  //使用此房间背景图
  _use_room_background: (param) => {
    return service.post("/live/room/background/isUse", param);
  },
  //类别查询接口
  _background_typeList: (param) => {
    return service.post("/live/room/background/typeList", param);
  },
  //根据类别获取房间背景图
  _background_list: (param) => {
    return service.post("/live/room/background/list", param);
  },
  //购买背景
  _background_pay: (param) => {
    return service.post("/live/room/background/pay", param);
  },
  //举报接口
  _report_submit: (param) => {
    return service.post("/web/api/report/submit", param);
  },
  //获取礼物优惠券
  _get_gift_coupon: (param) => {
    return service.get("/web/api/gift/v3/getGiftCoupon", {
      params: param,
    });
  },
  //我的优惠券列表
  _get_coupon_list: (param) => {
    return service.post("/web/api/coupon/v2/couponList", param);
  },
  //cdk兑换优惠券
  _exchange_sdk: (param) => {
    return service.post("/web/api/coupon/exchangeSDK", param);
  },
  //获取订单优惠券列表
  _get_order_coupons: (param) => {
    return service.get("/web/api/coupon/v2/received", {
      params: param,
    });
  },
  //获取单个订单的评论
  _get_order_comment: (param) => {
    return service.get("/web/api/review/getOrderComment", {
      params: param,
    });
  },
  //删除单个订单的评论
  _del_order_comment: (param) => {
    return service.post("/web/api/review/deleteOrderComment", param);
  },
  //修改单个订单的评论
  _edit_order_comment: (param) => {
    return service.post("/web/api/review/updateOrderComment", param);
  },
  //获取充值金额配置
  _get_charge_config: (param) => {
    return service.get("/web/api/recharge/abroad/pay/items", {
      params: param,
    });
  },
  //海外新支付接口
  _oversea_pay: (param) => {
    return service.get("/web/api/recharge/abroad/web/addOrder", {
      params: param,
    });
  },
  //获取海外支持的支付地区
  _get_pay_areas: (param) => {
    return service.get("/pay/api/areas", {
      params: param,
    });
  },
  //获取该地区码支持的充值包
  _get_pay_config_by_areas: (param) => {
    return service.get("/pay/api/getConfigByArea", {
      params: param,
    });
  },
  //获取该充值包下的支付列表
  _get_pay_item_by_config: (param) => {
    return service.get("/pay/api/v2/getItemByConfigId", {
      params: param,
    });
  },
  //获取语言字典
  _get_lang_dicts: (param) => {
    return service.get("/config/api/lang/getLangDicts", {
      params: param,
    });
  },
  //获取财富等级特权设置配置
  _get_wealth_set: (param) => {
    return service.get("/web/api/privilege/config", {
      params: param,
    });
  },
  //更新财富等级特权设置配置
  _update_wealth_set: (param) => {
    return service.post("/web/api/privilege/update", param);
  },
  //获取网易token
  _get_agora_token: (params) => {
    return service.get("/live/api/shunwang/obtainSignToken", { params });
  },
  //播放伴奏
  _music_play: (param) => {
    return service.get(`/web/music/get/${param.id}`, {
      params: param,
    });
  },
  //获取伴奏列表
  _get_music_list: (param) => {
    return service.get(`/web/music/list`, {
      params: param,
    });
  },
  _delete_my_music: (param) => {
    return service.post("/web/music/batchDelete", param);
  },
  _check_token: (params) => {
    return service.post("/user/api/checkToken", params);
  },
  // 盛游主体验证token
  _check_token_sy: (params) => {
    return service.post("/user/api/v3/checkToken", params);
  },
  // 验证 token - 苇渡登录换绑手机号
  _check_token_wd_bind: (param) => {
    return service.post("/user/api/back/authorize/checkToken", param);
  },
  //查询当前公会
  _get_sociaty_detail: (param) => {
    return service.get("/web/manage/querySociatyDetail", {
      params: param,
    });
  },
  //退出公会
  _apply_quit_sociaty: (param) => {
    return service.get("/web/manage/godApplyQuit", {
      params: param,
    });
  },
  //公会发起续约大神同意、拒绝续约
  _god_aduit_renewal: (param) => {
    return service.get("/web/manage/auditRenewal", {
      params: param,
    });
  },
  //大神发起续约
  _god_apply_renewal: (param) => {
    return service.get("/web/manage/godApplyRenewal", {
      params: param,
    });
  },
  //大神支付退会手续费
  _god_sociaty_pay: (param) => {
    return service.get("/web/api/recharge/sociaty/pay", {
      params: param,
    });
  },
  //大神(同意拒绝)转会
  _god_transfer_apply: (param) => {
    return service.get("/web/sociaty/change/godAgree", {
      params: param,
    });
  },
  //实名认证
  _v4_realNameCertAuth: (param) => {
    return service.post("/web/api/v4/godEnter/realNameCertAuth", param);
  },
  //海外实名认证
  _v4_hk_realNameCertAuth: (param) => {
    return service.post("/pay/api/cert/v4/abroad/apply", param);
  },
  //解除风控验证
  _relieve_risk_validate: (param) => {
    return service.post("/user/api/risk/content/validate", param);
  },
  //资质申请
  _v5_addAptitude: (param) => {
    return service.post("/web/api/v5/godEnter/addAptitude", param);
  },
  //资质申请
  _v2_addAptitude: (param) => {
    return service.post("/web/api/v2/godEnter/addAptitude", param);
  },
  //完善基本资料
  _v5_perfectUserInfo: (param) => {
    return service.post("/web/api/v5/godEnter/perfectUserInfo", param);
  },
  //房间角色管理列表
  _get_room_role_list: (param) => {
    return service.get("/live/api/room/v2/queryRoleManage", {
      params: param,
    });
  },
  //获取别人信息
  _get_user_info_uid: (param) => {
    return service.get("/web/api/user/queryUserBan", {
      params: param,
    });
  },
  //获取用户在此房间对应的角色
  _get_user_role: (param) => {
    return service.get("/live/api/room/v2/queryUserRoomRole", {
      params: param,
    });
  },
  //获取用户防打扰/高级礼物特效/房间背景特效 开关
  _get_rules_byuid: (param) => {
    return service.get("/user/v2/api/info/v2/getRulesByUid", {
      params: param,
    });
  },
  //更改 用户防打扰/高级礼物特效/房间背景特效 开关
  _update_rules_byuid: (param) => {
    return service.get("/web/api/userRule/updateRulesByUid", {
      params: param,
    });
  },
  //获取双方关注状态
  _if_focused_each: (param) => {
    return service.get("/user/v2/api/friend/ifFocusedEach", {
      params: param,
    });
  },
  //获取双方关注状态
  _ask_focus: (param) => {
    return service.get("/web/api/friend/askFocusV2", {
      params: param,
    });
  },
  //获取双方关注状态
  _get_blank_list: (param) => {
    return service.get("/web/api/userRule/getBlackList", {
      params: param,
    });
  },
  //完善资料step1
  _get_update_step_one: (param) => {
    return service.get("/web/api/userInterest/updateStepOne", {
      params: param,
    });
  },
  //完善资料step2
  _get_update_step_two: (param) => {
    return service.get("/web/api/userInterest/updateStepTwo", {
      params: param,
    });
  },
  //完善资料step3
  _get_update_step_three: (param) => {
    return service.get("/web/api/userInterest/updateStepThree", {
      params: param,
    });
  },
  //完善资料step4
  _get_update_step_four: (param) => {
    return service.get("/web/api/userInterest/updateStepFour", {
      params: param,
    });
  },
  //获取所有提现方式
  _get_Withdraw_Types: (param) => {
    return service.get("/web/api/v4/wallet/getWithdrawExtract", {
      params: param,
    });
  },
  //解绑提现方式
  _unset_Withdraw: (param) => {
    return service.post("/web/api/v4/wallet/unSetWithdraw", param);
  },
  //增加提现方式
  _set_Withdraw: (param) => {
    return service.post("/web/api/v4/wallet/setWithdrawExtract", param);
  },
  // 修改提现方式信息
  _update_Withdraw: (param) => {
    return service.post("/pay/api/bank/updateBankPhone", param);
  },
  //发起提现
  _lanuch_Withdraw: (param) => {
    return service.post("/web/api/v4/wallet/extractWithdrawCash", param);
  },
  //查询所有声音类型
  _query_sound_list: (param) => {
    return service.post("/web/heart/querySoundList", param);
  },
  //保存用户喜欢的声音类型
  _save_like_sound: (param) => {
    return service.post("/web/heart/saveUpdateUserLikeSound", param);
  },
  //设置登录密码
  _set_pwd: (param) => {
    return service.post("/web/api/user/setPassword", param);
  },
  //重设密码
  _reset_pwd: (param) => {
    return service.post("/web/api/user/resetPassword", param);
  },
  //密码登录
  _account_login: (params) => {
    return service.post('/user/api/v3/accountLogin', params);
  },
  //重设密码（忘记密码）
  _forget_pwd: (param) => {
    return service.post("/web/api/user/forgetPassword", param);
  },
  //查询大神变更明细
  _get_god_change_detail: (params) => {
    return service.get("/user/api/god/change/findGodChangeInfoByUid", { params });
  },
  //账号注销
  _account_out: (param) => {
    return service.post("/web/api/user/accountOut", param);
  },
  //大神注销
  _god_out: (param) => {
    return service.post("/user/api/god/change/cancelGod", param);
  },
  // 查询是否可以立即注销
  _get_account_out_immediate_status: (params) => {
    return service.get("/user/api/account/out/immediateStatus", { params });
  },
  // 立即注销账号
  _account_out_immediate: (param) => {
    return service.post("/user/api/account/out/immediate", param);
  },
  //活动奖励靓号列表
  _pretty_active: (param) => {
    return service.post("/web/api/auction/queryBeautifulNoByUid", param);
  },
  //竞拍靓号列表
  _auction_list: (param) => {
    return service.post("/web/api/auction/queryBeautifulNoAuctionList", param);
  },
  //竞拍靓号出价列表
  _auction_pay_list: (param) => {
    return service.post("/web/api/auction/queryAuctionList", param);
  },
  //我的出价
  _auction_my_pay: (param) => {
    return service.post("/web/api/auction/queryUserAuctionList", param);
  },
  //出价
  _auction_pay: (param) => {
    return service.post("/web/api/auction/auctionBeautifulNo", param);
  },
  //使用靓号
  _pretty_use: (param) => {
    return service.post("/web/api/auction/useBeautifulNo", param);
  },
  //靓号续期
  _pretty_renewal: (param) => {
    return service.post("/web/api/auction/renewalBeautifulNo", param);
  },
  //勋章类型查询
  _get_medal_by_type: (param) => {
    return service.get("/web/api/medal/allByUid", {
      params: param,
    });
  },
  //我(TA)的勋章总览
  _get_medal_my: (param) => {
    return service.get("/web/api/medal/view", {
      params: param,
    });
  },
  //我(TA)的勋章总览
  _get_medal_v2_my: (param) => {
    return service.get("/web/api/medal/view2", {
      params: param,
    });
  },
  //修改勋章佩戴状态
  _change_medal_status: (param) => {
    return service.post("/web/api/medal/updateDressStatus", param);
  },
  //大神详情v4
  _get_v4_new_god_detailed: (params) => {
    return service.get("/user/api/god/v5/getNewGodDetailed", { params });
  },
  //关系主页信息
  _get_affinity_details: (params) => {
    return service.get("/order/api/relationIndex/getRelationIndex", { params });
  },
  //关系配置
  _get_affinity_config: (params) => {
    return service.get("/order/api/invitationInfo/getIntimateConfig", { params });
  },
  //分页查询 可缔结/不可缔结 关系
  _get_affinity_conclude_page: (params) => {
    return service.get("/order/api/invitationInfo/pageConcludeRelation", { params });
  },
  //分页查询邀请记录
  _get_affinity_invite_page: (params) => {
    return service.get("/order/api/invitationInfo/pageInvitationRecord", { params });
  },
  //分页查询亲密关系
  _get_affinity_page: (params) => {
    return service.get("/order/api/intimateSend/getUserRelationPage", { params });
  },
  //查询麦上亲密关系(只查亲密关系&趣味关系)
  _get_mic_intimate_relation: (params) => {
    return service.get("/order/api/intimateSpace/getMicIntimateRelation", { params });
  },
  //查询亲密空间信息
  _get_affinity_space_info: (params) => {
    return service.get("/order/api/intimateSpace/getSpaceInfo", { params });
  },
  //查询亲密空间等级装扮信息
  _get_affinity_space_dress_info: (params) => {
    return service.get("./order/api/intimateSpace/getDressingLevel", { params });
  },
  //分页查询趣味关系
  _get_interest_affinity_page: (params) => {
    return service.get("/order/api/relationIndex/getFunRelationPage", { params });
  },
  //查询趣味关系详情
  _get_interest_affinity_detail: (params) => {
    return service.get("/order/api/relationIndex/getFunRelationDetail", { params });
  },
  //解除关系页详情
  _get_affinity_delete_detail: (params) => {
    return service.get("/order/api/cancelRelation/cancel/apply/route", { params });
  },
  //解除关系页详情 - 从消息跳转
  _get_affinity_delete_detail_msg: (params) => {
    return service.get("/order/api/cancelRelation/cancel/apply/detail", { params });
  },
  //解除关系
  _get_affinity_delete: (params) => {
    return service.post("/order/api/cancelRelation/sendCancel", params);
  },
  //解除关系 同意/拒绝
  _get_affinity_delete_reject_or_accept: (params) => {
    return service.post("/order/api/cancelRelation/cancelRejectOrAccept", params);
  },
  //信物墙排序
  _token_wall_sort: (params) => {
    return service.post("/order/api/intimateSpace/replaceRank", params);
  },
  //赠送信物
  _send_token_card: (params) => {
    return service.post("/order/api/intimateSend/sendGiftUserRelation", params);
  },
  //赠送趣味卡接口
  _send_interest_card: (params) => {
    return service.post("/order/api/intimateSend/sendFunRelationCard", params);
  },
  //发起关系邀请/收到关系邀请 详情
  _get_affinity_invite_details: (params) => {
    return service.get("/order/api/invitationInfo/getInvitationDetail", { params });
  },
  //发起关系邀请/收到关系邀请 详情 - 消息跳转
  _get_affinity_invite_details_msg: (params) => {
    return service.get("/order/api/invitationInfo/getDetailByInviteOrderNo", { params });
  },
  //发起亲密关系邀请
  _affinity_send_invite: (params) => {
    return service.post("/order/api/invitation/sendInvitation", params);
  },
  //查询邀请列表页面相关数据(关系&信物)
  _get_affinity_invite_info: (params) => {
    return service.get("/live/api/mytool/queryInviteChooseInfo", { params });
  },
  //同意/拒绝 接受邀请
  _affinity_accept_invite: (params) => {
    return service.post("/order/api/invitation/rejectOrAccept", params);
  },
  //解锁关系位
  _affinity_unlock_bit: (params) => {
    return service.post("/order/api/relationBit/unlockBit", params);
  },
  //赠送金币
  _gold_gift_other: (param) => {
    return service.post("/web/api/wallet/v2/giveGold", param);
  },
  //获取他人的基本信息
  _get_user_by_uid: (param) => {
    return service.get("/user/api/base/v2/getSimpleUserInfo", {
      params: param,
    });
  },
  //获取金币汇率
  _get_gold_rate: (param) => {
    return service.get("/web/api/wallet/getGoldRate", {
      params: param,
    });
  },
  //跨房pk-获取可以挑战的房间列表
  _find_pk_rooms: (param) => {
    return service.get("/live/api/roomPk/findPkRoom", {
      params: param,
    });
  },
  //跨房pk-发送房间挑战请求
  _send_pk_req: (param) => {
    return service.post("/live/api/roomPk/sendPkReq", param);
  },
  //跨房pk-接受/拒绝 挑战请求
  _deal_pk_req: (param) => {
    return service.post("/live/api/roomPk/dealPkReq", param);
  },
  //房内pk-开启pk
  _team_pk_start: (param) => {
    return service.get("/live/api/pk/startTeam", {
      params: param,
    });
  },
  //房内pk-开启pk
  _team_pk_stop: (param) => {
    return service.get("/live/api/pk/endTeam", {
      params: param,
    });
  },
  //跨房PK战绩
  _room_pk_list: (param) => {
    return service.get("/live/api/roomPk/getMyRoomPkList", {
      params: param,
    });
  },
  //跨房PK战绩
  _get_team_pk_rank: (param) => {
    param.rmode = 8;
    return service.get("/live/api/roomPk/getTeamPkRank", {
      params: param,
    });
  },
  //获取房间是否有红包
  _get_room_redpacket: (param) => {
    return service.post("/live/api/redPacket/queryRoomRedPackage", param);
  },
  //查询福袋详情
  _get_room_lucky_bag_detail: (params) => {
    return service.get("/liveV2/api/lucky/bag/detail", { params });
  },
  //创建福袋
  _create_room_lucky_bag: (param) => {
    return service.post("/liveV2/api/lucky/bag/create", param);
  },
  //发送口令上报接口
  _send_room_lucky_bag_command: (params) => {
    return service.get("/liveV2/api/lucky/bag/sendPassword/report", { params });
  },
  //创建红包
  _create_red_packet: (param) => {
    return service.post("/live/api/redPacket/addPacket", param);
  },
  //抢红包
  _receive_red_packet: (param) => {
    return service.post("/live/api/redPacket/receivePacket", param);
  },
  //摇骰子
  _get_use_plug: (param) => {
    return service.post("/live/api/plug/usePlug", param);
  },
  // 微信公众号登录查询状态
  _get_wechat_polling: (params) => {
    return service.get("/web/api/user/wechatPolling", { params });
  },
  // 盛游微信公众号登录查询状态
  _get_wechat_polling_sy: (params) => {
    return service.get("/web/api/user/login/v2/wechatPolling", { params });
  },
  // 开宝瓶
  _open_bottle: (param) => {
    return service.post("/order/api/bottle/open", param);
  },
  //赠送礼物
  _give_gift: (param) => {
    return service.post("/order/api/gift/v2/giveGift", param);
  },
  //查询组合礼物
  _get_combo_gift: (params) => {
    return service.get("/live/api/goods/findRoomGoodsByGoodsId", { params });
  },
  //查询合成图信息
  _get_composite_info: (param) => {
    return service.get("/goods/api/compositeBag/findUserChart", { param });
  },
  //清屏功能
  _clean_screen: (param) => {
    return service.post("/live/api/plug/cleanScreen", param);
  },
  //查询道具商城列表
  _query_all_prop_list: (param) => {
    return service.get("/live/api/prop/queryAllPropList", {
      params: param,
    });
  },
  //查询道具商城列表
  _query_all_prop_list_v2: (param) => {
    return service.get("/live/api/prop/v2/queryAllPropList", {
      params: param,
    });
  },
  //查询道具商城列表
  _query_all_prop_list_v3: (param) => {
    return service.get("/live/api/prop/v3/queryAllPropList", {
      params: param,
    });
  },
  //查询热门商品列表
  _query_all_hot_prop_list: (param) => {
    return service.get("/live/api/prop/queryAllHotPropList", {
      params: param,
    });
  },
  //查询商品列表
  _query_prop_business_list: (param) => {
    return service.get("/live/api/prop/queryPropBusinessList", {
      params: param,
    });
  },
  //查询商品详情
  _query_prop_sku_list: (param) => {
    return service.get("/live/api/prop/queryPropSkuList", {
      params: param,
    });
  },
  //购买商品
  _buy_prop: (params) => {
    return service.get("/live/api/prop/buyPropSign", { params });
  },
  //续期卡续期
  _renewal_prop: (params) => {
    return service.post("/goods/api/car/cardRenewal/useRenewal", params);
  },
  //道具订单记录
  _query_user_prop_order_list: (param) => {
    return service.get("/live/api/prop/queryUserPropOrderList", {
      params: param,
    });
  },
  //我的道具列表
  _get_tool_by_type: (param) => {
    return service.get("/live/api/mytool/toolByType", {
      params: param,
    });
  },
  //我的道具详情
  _get_tool_Info: (param) => {
    return service.get("/live/api/mytool/toolInfo", {
      params: param,
    });
  },
  //装扮道具
  _get_dress_tool: (param) => {
    return service.get("/live/api/mytool/dressTool", {
      params: param,
    });
  },
  //卸下装扮道具
  _get_undress_tool: (param) => {
    return service.get("/live/api/mytool/undressTool", {
      params: param,
    });
  },
  //获取弹幕列表
  _get_user_bullet_list: (param) => {
    return service.get("/live/api/prop/v4/queryUserBulletList", {
      params: param,
    });
  },
  //获取麦位框可以使用的房间列表
  _get_room_vip_detail: (param) => {
    return service.get("/live/api/mytool/roomVipDetail", {
      params: param,
    });
  },
  //查询关注列表
  _query_user_friend_list: (param) => {
    return service.get("/live/api/prop/queryUserFriendList", {
      params: param,
    });
  },
  //查询新人注册礼包新接口
  _get_new_user_reg_pack_list: (param) => {
    return service.get("/web/api/activity/newUserRegPack/list", {
      params: param,
    });
  },
  //查询点唱配置礼物信息
  _get_sing_config: (param) => {
    return service.get("/web/sing/querySingConfig", {
      params: param,
    });
  },
  //点歌下单
  _send_song_order: (params) => {
    return service.get("/web/sing/songOrder", { params });
  },
  //点歌下单 v2
  _send_song_order_v2: (params) => {
    return service.post("/web/sing/v2/songOrder", params);
  },
  //获取用户随机昵称
  _get_random_nick_name: (param) => {
    return service.get("/web/api/user/config/getRandomNickName", {
      params: param,
    });
  },
  //获取默认头像
  _get_default_avatar: (param) => {
    return service.get("/web/api/user/config/getDefaultAvatar", {
      params: param,
    });
  },
  //设置独特身份
  _set_user_config: (param) => {
    return service.post("/web/api/user/config/setUserConfig", param);
  },
  //获取用户信息是否完善
  _get_user_info_complete_status: (param) => {
    return service.get("/user/v2/api/info/getUserInfoCompleteStatus", {
      params: param,
    });
  },
  //房间信息-用户是否进入房间
  _get_user_if_enter_room: (param) => {
    return service.get("/recommend/api/user/recommend/room/getUserIfEnterRoom", {
      params: param,
    });
  },
  //房间信息-用户进入房间
  _user_enter_room: (param) => {
    return service.post("/recommend/api/user/recommend/room/userEnterRoom", param);
  },
  //钱包-判断是否需要弹框提示签约
  _get_withdraw_dialog_for_Pc: (param) => {
    return service.get("/web/api/wallet/sign/getWithdrawDialogForPC", {
      params: param,
    });
  },
  //钱包-计算手续费
  _get_cal_service_fee: (param) => {
    return service.get("/web/api/wallet/sign/calServiceFee", {
      params: param,
    });
  },
  //钱包-用户钱包基础信息
  _get_wallet_info: (param) => {
    return service.get("/web/api/wallet/info/getWalletInfo", {
      params: param,
    });
  },
  //修改房间公告
  _update_room_announcement: (param) => {
    return service.post("/live/api/announcement/updateRoomAnnouncement", param);
  },
  //实名认证-查询用户是否已进行实名
  _get_certification_info: (param) => {
    return service.get("/user/v2/api/cert/findCertificationInfo", {
      params: param,
    });
  },
  //实名认证-认证
  _post_certification_info: (param) => {
    return service.post("/web/api/user/certification/cert", param);
  },
  //【提现改版】去到提现页
  _get_go_to_withdraw: (params) => {
    return service.get("/web/api/wallet/sign/goToWithdraw", { params });
  },
  //【提现改版】查询用户提现账户
  _get_withdraw_account_list: (params) => {
    return service.get("/web/api/wallet/sign/withdrawAccountList", { params });
  },
  //获取用户的靓号信息
  _get_user_beatiful_no: (params) => {
    return service.get("/web/api/user/info/getBeatifulNo", { params });
  },
  //查询首充活动接口
  _get_first_recharge_activity: (params) => {
    return service.get("/pay/api/recharge/activity/getFirstRechargeActivity", {
      params,
    });
  },
  //查询用户是否满足首充活动
  _get_user_is_first_recharge: (params) => {
    return service.get("/pay/api/recharge/activity/getUserIsFirstRecharge", {
      params,
    });
  },
  //房间周榜
  _get_room_week_tops: (params) => {
    return service.get("/live/api/room/v2/weekTops", { params });
  },
  //【礼物之王】 总榜
  _get_gift_total_rank: (params) => {
    return service.get("/web/api/rank/gift/v2/getGiftTotalRank", { params });
  },
  //【礼物之王】 单榜
  _get_this_week_gift_single_rank: (params) => {
    return service.get("/web/api/rank/gift/v2/getThisWeekGiftSingleRank", {
      params,
    });
  },
  //排行榜 - 上周财富榜Top3
  _get_last_week_wealth_rank: () => {
    return service.get("/web/api/rank/wealth/v2/getLastWeekWealthRank");
  },
  //排行榜 - 上周魅力榜Top3
  _get_last_week_glamour_rank: () => {
    return service.get("/web/api/rank/glamour/v2/getLastWeekGlamourRank");
  },
  //【大神我的礼物】用户财富值魅力值
  _get_wealth_amount: (params) => {
    return service.get("/web/api/userbag/getWealthAmount", { params });
  },
  //【大神我的礼物】礼物总数
  _get_gift_amount: (params) => {
    return service.get("/web/api/userbag/getGiftAmount", { params });
  },
  //【贵族等级】查询用户贵族等级
  _get_noble_info: (params) => {
    return service.get("/user/v2/api/noble/nobleInfo", { params });
  },
  //SY 授权登录接口
  _sy_check_token: (param) => {
    return service.post("/web/api/activity/authorize/checkToken", param);
  },
  //庆典 抢宝箱
  _get_lucky_box: (param) => {
    return service.post("/hd/year/room/box/getLuckyBox", param);
  },
  //派单结束
  _room_endDispatch: (param) => {
    return service.post("/live/api/msg/endDispatch", param);
  },
  // 获取用户大神入驻审核状态
  _get_personal_user_type: (params) => {
    return service.get("/user/api/personal/userType", { params });
  },
  // 取消审核中的 头像，照片墙，大神入驻
  _user_cancel_apply: (params) => {
    return service.get("/user/api/personal/userInfo/cancelApply", { params });
  },
  // 取消已审核的视频
  _user_cancel_authByVideo: (params) => {
    return service.post(
      "/web/api/v2/godEnter/video/cance/authentication",
      params
    );
  },
  // 取消资质审核
  _user_cancel_category: (params) => {
    return service.get("/user/api/personal/cancelCategory", { params });
  },
  //一键上麦
  _onekey_autoMicrophone: (param) => {
    return service.post("/live/api/room/autoMicrophone", param);
  },
  //派单厅用户上麦上报(方案有异议)
  _oneorder_upMicrophone: (param) => {
    return service.post("/live/api/room/upMicrophone", param);
  },
  //历史派单大神列表
  _room_order_god_list: (params) => {
    return service.get("/live/api/room/recommend/god/list", { params });
  },
  // 推荐公会列表
  _get_recommend_sociaty_list: (params) => {
    return service.get("/web/api/sociatyInfo/getRecommendSociatyList", {
      params,
    });
  },
  // 申请加入公会
  _apply_join_sociaty: (param) => {
    return service.post("/web/api/sociatyInfo/applyJoinSociaty", param);
  },
  // 取消加入公会
  _cancel_apply_join_sociaty: (param) => {
    return service.post("/web/api/sociatyInfo/cancelApplyJoinSociaty", param);
  },
  // 根据公会 code 查询公会信息
  _get_sociaty_info_by_code: (params) => {
    return service.get("/web/api/sociatyInfo/getSociatyInfoByCode", { params });
  },
  // 麦上互动消息
  _send_room_hudong_msg: (param) => {
    return service.post("/live/api/hudong/v2/game", param);
  },
  // 获取趣味玩法列表
  _get_room_activity_list: (params) => {
    return service.get(
      "/config/api/funGamePlay/getConfig",
      { params }
    );
  },
  // 阅读大额充值协议
  _read_max_recharge_agreement: (param) => {
    return service.post("/web/api/wallet/info/read/transfer/agreement", param);
  },
  // 获取官方推荐房间
  _get_new_room_list: (params) => {
    return service.get("/live/api/room/v2/queryNewRoomList", { params });
  },
  // 获取客服链接 Token
  _get_custom_service: (params) => {
    return service.get("/user/api/customer/v2/userLogin", { params });
  },
  // 查询可申请的类别
  _get_findApplySimpleByUid: (params) => {
    return service.get("/user/api/skill/findApplySimpleByUid", { params });
  },
  // 获取用户申请进度
  _get_findGodApplyProgress: (params) => {
    return service.get("/user/api/skill/findGodApplyProgress", { params });
  },
  // 获取技能列表
  _get_findBySkillType: (params) => {
    return service.get("/user/api/skill/findBySkillType", { params });
  },
  // 根据用户id和品类id查询品类申请详情
  _find_GodCategoryInfoByUid: (params) => {
    return service.get("/user/api/skill/findGodCategoryInfoByUid", { params });
  },
  // 资质申请
  _v6_addAptitude: (param) => {
    return service.post("/user/api/skill/addNewCategory", param);
  },
  // 获取用户基本资料
  _find_GodSimpleByUid: (params) => {
    return service.get("/user/api/skill/findGodSimpleByUid", { params });
  },
  // 修改用户基本资料
  _update_GodSimple: (param) => {
    return service.post("/user/api/skill/updateGodSimple", param);
  },
  // 获取学习视频地址
  _get_StudyVedio: (params) => {
    return service.get("/user/api/skill/getStudyVedio", { params });
  },
  // 按月查询魅力值记录
  _get_glamourDetailByMonth: (params) => {
    return service.get("/user/api/glamour/getGlamourDetailByMonth", { params });
  },
  // 查看入驻大神开关状态
  _get_join_god_switch: (params) => {
    return service.get("/config/api/switch/getSwitch", {
      params: { ...params, key: "settledSwitch" },
    });
  },
  // 初始化验证码
  _get_register_geetest: (params) => {
    return service.get("/user/api/verify/v2/geetest/register", { params: { t: Date.now(), ...params } });
  },
  // 获取大神是否有同资质进行中的订单
  _get_god_has_busy: (params) => {
    return service.get("/web/api/order/god/has/busy", {
      params: { ...params, key: "settledSwitch" },
    });
  },
  // 获取用户房间vip卡列表
  _get_user_room_vips: (params) => {
    return service.get("/user/api/info/v2/roomVips", { params });
  },
  // 获取用户房间VIP信息
  _get_user_vip_progress: (params) => {
    return service.get("/live/api/room/vipProgress", { params });
  },
  // 派单房获取订单状态
  _get_grab_order_status: (params) => {
    return service.get("/live/api/msg/v2/dispatchStatus", { params });
  },
  // 获取单个技能的选择信息
  _get_all_category_config_item: (params) => {
    return service.get("/user/api/skill/findAllCategoryConfigItem", { params });
  },
  // 修改技能信息
  _post_update_category_config: (params) => {
    return service.post("/user/api/god/updateGodCategory", params);
  },
  // 查询是否存在折扣订单
  _get_order_has_discount: (params) => {
    return service.get("/web/api/order/has/discount", { params });
  },
  // 获取即构 RTC token
  _get_zrtc_token: (params) => {
    return service.get("/live/api/im/rtcServer/token", { params });
  },
  // 获取即构 RTC token (游客)
  _get_zrtc_token_anonymous: (params) => {
    return service.get("/live/api/im/rtcServer/pull/token", { params });
  },
  // 获取 code
  _get_room_pre_detail: (params) => {
    return service.get("/liveV2/api/room/v2/preDetail", { params });
  },
  // 服务端上麦
  _post_server_up_microphone: (params) => {
    return service.post("/liveV2/api/room/queue/upMicrophone", params)
  },
  // 服务端闭麦/开麦
  _post_server_change_mic: (params) => {
    return service.post("/liveV2/api/room/queue/changeMic", params)
  },
  // 极验校验
  _post_risk_validate: (params) => {
    return service.post("/user/api/risk/validate", params);
  },
  // 开启/关闭语聊房
  _post_switch_room_status: (params) => {
    return service.post("/live/api/room/switch/room/status", params);
  },
  // 歌单列表
  _get_song_list: (params) => {
    return service.get("/song/api/sheet/stat", { params });
  },
  // 歌单所有歌曲
  _get_song_item: (params) => {
    return service.get("/song/api/sheet/songAllList", { params });
  },
  // 主持人添加歌曲查询的歌单
  _get_song_item_master: (params) => {
    return service.get("/song/api/sheet/room/song/page", { params });
  },
  // 歌单封面图配置
  _get_song_cover: (params) => {
    return service.get("/config/api/home/sheet/coverConfig", { params });
  },
  // 搜索歌曲
  _search_song_item: (params) => {
    return service.get("/song/api/search/related/v2", { params });
  },
  // 歌单专属推荐
  _get_song_recommend: (params) => {
    return service.get("/song/api/search/recommend", { params });
  },
  // 歌单专属推荐歌曲
  _get_song_recommend_item: (params) => {
    return service.get("/song/api/search/category/detail", { params });
  },
  // 获取热搜榜
  _get_search_hot: (params) => {
    return service.get("/song/api/search/hot", { params });
  },
  // 创建歌单
  _song_create: (params) => {
    return service.post("/user/api/songList/createSongList", params);
  },
  // 编辑歌单
  _song_update: (params) => {
    return service.post("/user/api/songList/updateSongList", params);
  },
  // 置顶歌单
  _song_top: (params) => {
    return service.post("/song/api/sheet/top", params);
  },
  // 删除歌单
  _song_delete: (params) => {
    return service.post("/song/api/sheet/delete", params);
  },
  // 添加歌曲到歌单
  _song_item_add: (params) => {
    return service.post("/song/api/sheet/custom/add/song", params);
  },
  // 添加歌曲到歌单v2
  _song_item_add_v2: (params) => {
    return service.post("/song/api/sheet/custom/single/add/song/v2", params);
  },
  // 删除歌曲
  _song_item_delete: (params) => {
    return service.post("/song/api/sheet/custom/remove/songs", params);
  },
  // 歌曲排序
  _song_item_sort: (params) => {
    return service.post("/song/api/sheet/updateSheetSongSort", params);
  },
  // 【资质考核】查询用户资质考核情况
  _get_user_exam_info: (params) => {
    return service.get("/user/api/categoryExam/findUserExamByUid", { params });
  },
  // 【资质考核】取消考核预约
  _song_exam_cancel: (params) => {
    return service.post("/user/api/categoryExam/cancelExam", params);
  },
  // 【资质考核】添加考核预约
  _song_exam_add: (params) => {
    return service.post("/user/api/categoryExam/orderExam", params);
  },
  // 添加点唱待唱列表
  _post_song_choose_add: (params) => {
    return service.post("/web/sing/v2/choose/song", params);
  },
  // 查询点唱待唱列表
  _get_song_choose_list: (params) => {
    return service.get("/live/api/song/choose/page", { params });
  },
  // 开始唱歌
  _post_song_choose_start: (params) => {
    return service.post("/live/api/song/choose/start", params);
  },
  // 点唱结束待唱
  _post_song_choose_end: (params) => {
    return service.post("/live/api/song/choose/end", params);
  },
  // 点唱删除待唱
  _post_song_choose_remove: (params) => {
    return service.post("/live/api/song/choose/remove", params);
  },
  // 点唱排序待唱
  _post_song_choose_update_sort: (params) => {
    return service.post("/live/api/song/choose/updateSort", params);
  },
  // 点唱获取歌曲数量
  _get_song_choose_count: (params) => {
    return service.get("/live/api/song/room/choose/count", { params });
  },
  // 点唱获取歌曲信息
  _get_song_choose_info: (params) => {
    return service.get("/live/api/song/choose/song/info", { params });
  },
  // 上报下载完成的歌曲
  _post_song_download_finish: (params) => {
    return service.post("/live/api/song/choose/song/downloadOk", params);
  },
  // 查询当前歌曲是否可以播放
  _get_song_choose_status: (params) => {
    return service.get("/live/api/song/choose/song/status", { params });
  },
  //查询曲风标签列表
  _get_musics_list: (param) => {
    return service.get("/user/api/categoryExam/findUserGenreList", {
      params: param,
    });
  },
  // 保存曲风标签
  _save_musics: (params) => {
    return service.post("/user/api/categoryExam/updateUserShowCategoryLabel", params);
  },
  //获取token
  _game_login: (param) => {
    return service.get("/game/api/user/login", {
      params: param,
    });
  },
  //匿名获取token
  _game_anonymity_login: (param) => {
    return service.get("/game/api/user/anonymous/token", {
      params: param,
    });
  },
  //游戏列表获取
  _get_game_list: (params) => {
    return service.get("/game/api/hall/pageList", { params });
  },
  // 查询房间可用模版
  _get_room_mode_list: (params) => {
    return service.get("/live/api/room/modeList", { params });
  },
  // 互动游戏列表
  _get_interactive_game_list: (params) => {
    return service.get("/game/api/hall/interactive/pageList", { params });
  },
  // 设置互动游戏
  _get_interactive_game_setting: (params) => {
    return service.get("/game/api/interactive/v2/gameSetting", { params });
  },
  // 开始互动游戏
  _post_interactive_start: (params) => {
    return service.post("/game/api/interactive/v2/openGame", params)
  },
  // 互动游戏礼物列表
  _get_interactive_gift_list_v2: (params) => {
    return service.get("/config/api/gift/getGameGiftV2", { params });
  },
  // 取消启动中的游戏
  _post_interactive_cancel: (params) => {
    return service.post("/game/api/interactive/cancel/starting", params);
  },
  // 结束游戏
  _post_interactive_close: (params) => {
    return service.post("/game/api/interactive/v2/close", params);
  },
  // 查询游戏启动状态
  _get_interactive_game_start_status: (params, config) => {
    return service.get("/game/api/interactive/v2/gameStatus", { params, ...config });
  },
  // 加入游戏
  _get_interactive_join_game: (params) => {
    return service.get("/game/api/interactive/v2/joinGame", { params });
  },
  // 游戏助力
  _get_interactive_assist_game: (params) => {
    return service.post("/game/api/interactive/v2/assistTeamGame", params);
  },
  // 获取本局游戏榜单
  _get_interactive_settle_rank: (params) => {
    return service.get("/game/api/interactive/v2/getGameSettleRank", { params });
  },
  // 查询自己加入阵营情况
  _get_interactive_user_camp: (params) => {
    return service.post("/game/api/interactive/v2/queryCamp", params);
  },
  // 查询游戏大厅列表
  _get_interactive_hall_list: (params) => {
    return service.get("/game/api/interactive/v2/pk/room/hall/list", { params });
  },
  // 房主开启游戏
  _post_interactive_start_pk: (params) => {
    return service.post("/game/api/interactive/v2/pk/open/session", params);
  },
  // 提醒房主开启游戏
  _post_interactive_start_tip_pk: (params) => {
    return service.post("/game/api/interactive/v2/pk/notice/start", params);
  },
  // 加入游戏 - pk
  _post_interactive_join_pk: (params) => {
    return service.post("/game/api/interactive/v2/pk/session/join", params);
  },
  // 发起邀请
  _post_interactive_invite_pk: (params) => {
    return service.post("/game/api/interactive/v2/pk/session/invite", params);
  },
  // 接受/拒绝 跨房邀请 - pk
  _post_interactive_reject_or_accept_pk: (params) => {
    return service.post("/game/api/interactive/v2/pk/session/rejectOrAccept", params);
  },
  // 踢出当局游戏 - pk
  _post_interactive_kick_out_pk: (params) => {
    return service.post("/game/api/interactive/v2/pk/kick/out/session", params);
  },
  // 退出当前房间游戏PK
  _post_interactive_quit_pk: (params) => {
    return service.post("/game/api/interactive/v2/pk/quit/session", params);
  },
  // 防沉迷认证
  _post_cert_secure_indulge: (params) => {
    return service.post("/pay/api/cert/v2/secure/indulge", params);
  },
  // 获取工单的跳转地址
  _get_report_jump_order_url: (params) => {
    return service.get("/bigdata/api/report/jumpWorkOrderUrl", { params });
  },
  // 获取图鉴套系数量
  _get_user_suit_wall: (params) => {
    return service.get("/user/api/gift/findUserSuitWallVo", { params });
  },
  // 获取礼物图鉴
  _get_user_gift_wall_v3: (params) => {
    return service.get("/user/api/gift/findUserGiftWallVo", { params });
  },
  // 获取道具图鉴(座驾)
  _get_user_prop_car: (params) => {
    return service.get("/goods/api/props/collect/car", { params });
  },
  // 获取道具图鉴(座驾)单个详情
  _get_user_prop_car_detail: (params) => {
    return service.get("/goods/api/props/collect/car/detail", { params });
  },
  // 获取座驾图鉴
  _get_user_prop_car_all: (params) => {
    return service.get("/goods/api/car/suit/queryCarSuitBySearchUid", { params });
  },
  // 获取房间座驾(分页)
  _get_room_car_page: (params) => {
    return service.get("/live/api/room/prop/carParkPage", { params });
  },
  // 房间座驾停放信息
  _get_room_car_info: (params) => {
    return service.get("/live/api/room/prop/getCarParkInfo", { params });
  },
  // 停放座驾/趣味关系卡
  _park_car_card: (params) => {
    return service.post("/live/api/room/park/userPropPark", params);
  },
  // 取消停放座驾/关系卡
  _park_car_card_cancel: (params) => {
    return service.post("/live/api/room/park/userPropParkCancel", params);
  },
  // 座驾奖励
  _get_user_prop_car_award: (params) => {
    return service.get("/goods/api/props/collect/car/reward/detail", { params });
  },
  // 座驾领取奖励
  _get_user_prop_car_reward: (params) => {
    return service.post("/goods/api/props/collect/car/reward", params);
  },
  // 获取道具图鉴(非座驾)
  _get_user_prop_tool: (params) => {
    return service.get("/goods/api/props/collect/tool", { params });
  },
  // 获取礼物套系
  _get_user_suit_vo: (params) => {
    return service.get("/user/api/gift/findUserSuitVo", { params });
  },
  // 获取礼物套系中的礼物
  _get_user_suit_gift: (params) => {
    return service.get("/user/api/gift/findUserSuitGift", { params });
  },
  // 获取礼物详情
  _get_user_gift_detail: (params) => {
    return service.get("/user/api/gift/findUserGiftDetail", { params });
  },
  // 获取礼物等级列表
  _get_gift_rarity_list: (params) => {
    return service.get("/order/api/gift/findRarityList", { params });
  },
  // 获取派对房页面房间类型
  _get_base_room_dict: (params) => {
    return service.get("/config/api/base/dictList", { params });
  },
  // 获取派对房页面房间类型
  _get_base_home_dict: (params) => {
    return service.get("/config/api/base/homeDict", { params });
  },
  // 获取工单链接
  _get_work_order_link: (params) => {
    return service.get("/bigdata/api/jumpUrl/authUrl", { params });
  },
  // 获取月度考核状态
  _get_user_month_exam_status: (params) => {
    return service.get("/user/api/monthExam/findUserMonthExamStatus", { params });
  },
  // 获取安全中心状态
  _get_user_safe_status: (params) => {
    return service.get("/user/api/safe/findUserSafeStatus", { params });
  },
  // 查询待审核的实名信息接口
  _get_user_real_info: (params) => {
    return service.post("/pay/api/cert/v4/apply/info", { ...params });
  },
  // 根据用户查询实名路由状态
  _get_user_real_status: (params) => {
    return service.post("/pay/api/cert/v4/routeType", { ...params });
  },
  //海外用户私聊触发实名信息
  _get_user_msg_real_info: (params) => {
    return service.get("/user/api/info/cert/completion", { params });
  },
  // 用户实名申请撤销
  _user_real_recall: (params) => {
    return service.post("/pay/api/cert/v4/apply/recall", { ...params });
  },
  // 校验安全码
  _check_user_safe_pwd: (params) => {
    return service.get("/user/api/safe/checkUserSafePassword", { params });
  },
  // 三方加入游戏
  _other_game_join: (params) => {
    return service.get("/game/api/selfGame/joinSelfSeat", { params })
  },
  // 三方准备/取消游戏
  _other_game_preparatio: (params) => {
    return service.get("/game/api/selfGame/preparationSelfGame", { params })
  },
  // 三方退出游戏
  _other_game_quit: (params) => {
    return service.get("/game/api/selfGame/quitSelfGame", { params })
  },
  // 三方开始游戏
  _other_game_start: (params) => {
    return service.get("/game/api/selfGame/startSelfGame", { params })
  },
  // 三方获取游戏的基本信息
  _other_game_info: (params) => {
    return service.get("/game/api/selfGame/getInitSelfGameInfo", { params })
  },
  // 三方获取游戏的url
  _other_game_url: (params) => {
    return service.get("/game/api/selfGame/getSelfGameUrl", { params })
  },
  // 三方切换游戏场次
  _other_game_change_match: (params) => {
    return service.get("/game/api/selfGame/changeMatches", { params })
  },
  // 三方获取结算排名
  _other_game_get_rank: (params) => {
    return service.get("/game/api/selfGame/settingRank", { params })
  },
  // 获取新手星力/钱包引导
  _get_star_wallet_user_guide: (params) => {
    return service.get("/goods/api/starGuide/getUserGuide", { params })
  },
  // 新手星力/钱包/星力协议同意完成
  _post_star_wallet_user_guide: (params) => {
    return service.post("/goods/api/starGuide/doUserGuide", params)
  },
  // 获取秒杀活动列表
  _get_star_limit_list: (params) => {
    return service.get("/goods/api/secKillGoods/findList", { params })
  },
  // 购买秒杀
  _post_buy_limit_star_goods: (params) => {
    return service.post("/order/api/secKill/buySecKillGoods", params)
  },
  // 遇见星礼
  _get_star_point_gift: (params) => {
    return service.get("/order/api/gift/findStarPointGift", { params })
  },
  // 查询星力明细
  _get_user_star_details: (params) => {
    return service.get("/goods/api/userPoints/getUserPointsDetails", { params })
  },
  // 查询星力信息
  _get_user_star_common: (params) => {
    return service.get("/goods/api/star/getUserStartIndex", { params })
  },
  // 星力心愿好物分类列表
  _get_star_prop_tabs_type: (params) => {
    return service.get("/goods/api/starGoods/getPropToolType", { params })
  },
  // 星力心愿好物分类商品列表
  _get_star_prop_type_list: (params) => {
    return service.get("/goods/api/starGoods/queryListDirectGoods", { params })
  },
  // 星力查询商品详情
  _get_item_direct_goods_detail: (params) => {
    return service.get("/goods/api/starGoods/getDirectGoodsDetail", { params })
  },
  // 星力购买商品
  _post_buy_star_goods_order: (params) => {
    return service.post("/order/api/starOrder/buy/createStarOrder", params)
  },
  // 星力任务列表
  _get_star_task_day_list: (params) => {
    return service.get("/goods/api/starTask/queryDailyStarTaskByUid", { params })
  },
  // 星力任务列表
  _get_star_task_grow_list: (params) => {
    return service.get("/goods/api/starTask/queryGrowStarTaskByUid", { params })
  },
  // 星力任务领取
  _post_star_task_receive: (params) => {
    return service.post("/goods/api/starTask/receiveStar", params)
  },
  // 随机获取房间
  _get_random_recommend_room: (params) => {
    return service.get("/web/api/user/recommend/room/getRandomRecommendRoom", { params })
  },
  /// 座驾相关请求
  // 我的座驾列表
  _get_car_list: (params) => {
    return service.get("/goods/api/props/car/listConfigAll", { params })
  },
  // 查询星辰石、幸运石售价
  _get_car_stone_price: (params) => {
    return service.get("/goods/api/props/car/queryStonePrice", { params })
  },
  // 星辰石、幸运石 购买
  _post_car_stone_buy: (params) => {
    return service.post("/order/api/starOrder/buy/starStone", params)
  },
  // 装扮座驾
  _get_car_dress_level: (params) => {
    return service.get("/goods/api/props/car/dressLevel", { params })
  },
  // 查询背包碎片
  _get_car_bag_material_list: (params) => {
    return service.get("/goods/api/raffleActivityPrize/userBag/listAll", { params })
  },
  // 升级座驾
  _post_car_dress_updater: (params) => {
    return service.post("/goods/api/props/car/upgradeLevel", params)
  },
  // 房间座驾/趣味卡列表
  _get_room_car_card_list: (params) => {
    return service.get("/live/api/room/park/parkPage", { params })
  },
  // 用户趣味卡列表
  _get_user_card_list: (params) => {
    return service.get("/order/api/funCard/getUserPark", { params })
  },
  // 获取用户节目信息
  _get_user_program_content: (params) => {
    return service.get("/liveV2/api/room/star/queryUserProgram", { params })
  },
  // 活动模板配置
  _get_active_template_base: (params) => {
    return service.get("/liveV2/api/room/star/roomProgramSize", { params })
  },
  // 获取房间节目单
  _get_active_program_list: (params) => {
    return service.get("/liveV2/api/room/star/roomProgramList", { params })
  },
  // 新增节目单
  _post_add_active_program: (params) => {
    return service.post("/liveV2/api/room/star/addProgram", params)
  },
  // 编辑节目单
  _post_edit_active_program: (params) => {
    return service.post("/liveV2/api/room/star/modifyProgram", params)
  },
  // 删除节目单
  _get_delete_active_program: (params) => {
    return service.get("/liveV2/api/room/star/removeProgramById", { params })
  },
  // 改变节目单状态
  _get_change_active_program: (params) => {
    return service.get("/liveV2/api/room/star/changeProgramStatusById", { params })
  },
  // 获取房间当前表演者，和我的星光数量
  _get_room_bill_info: (params) => {
    return service.get("/liveV2/api/room/star/userRoomInfo", { params })
  },
  // 用户获取星力记录
  _get_user_star_record: (params) => {
    return service.get("/liveV2/api/room/star/userStarRule", { params })
  },
  // 星光投票
  _get_vote_program: (params) => {
    return service.get("/liveV2/api/room/star/voteProgramById", { params })
  },
  // 点唱模板上下演出位
  _post_click_music_song_status: (params) => {
    return service.post("/live/api/song/choose/changeSongStatus", params)
  },
  // 战场实时数据
  _get_game_time_top_rank: (params) => {
    return service.get("/game/api/interactive/v2/getGameDataTopRank", { params })
  },
  // 战场实时数据 - 用户
  _get_game_time_user_detail: (params) => {
    return service.get("/game/api/interactive/v2/getGameDataTopRankDetail", { params })
  },
  // 互动游戏切换视角
  _set_game_angle_view: (params) => {
    return service.get("/game/api/interactive/v2/setAngleView", { params })
  },
  // 互动游戏拒绝跨房PK邀请
  _interact_pk_reject: (params) => {
    return service.get("/game/api/interactive/pk/room/reject", { params })
  },
  // 互动游戏跨房PK邀请房间列表
  _get_interact_pk_invite_room: (params) => {
    return service.get("/game/api/interactive/v2/pk/room/pageList", { params })
  },
  // 互动游戏获取房间模式
  _get_interact_game_mode: (params) => {
    return service.get("/game/api/interactive/v2/query/gameMode", { params })
  },
  // 互动游戏获取星力精英道具
  _get_interact_game_star_prop: (params) => {
    return service.get("/game/api/PeakGame/getStarSoldier", { params })
  },
  // 互动游戏赠送星力精英道具
  _post_interact_game_star_prop_buy: (params) => {
    return service.post("/game/api/PeakGame/buyStarSoldier", params)
  },
  // 互动游戏创建房间
  _post_interact_game_create: (params) => {
    return service.post("/game/api/interactive/v2/pk/session/create", params)
  },
  // 查询用户大神分主页分数
  _get_user_god_score_info: (params) => {
    return service.get("/user/v2/api/godScore/userInfo", { params })
  },
  // 根据用户id获取大神分变化赛季明细
  _get_user_god_score_season_detail: (params) => {
    return service.get("/user/v2/api/godScore/findUserScoreSeasonDetail", { params })
  },
  // 获取大神分记录明细
  _get_user_god_score_record_detail: (params) => {
    return service.get("/bigdata/api/user/task/statistics", { params })
  },
  // 查询大神分任务进度
  _get_god_score_task: (params) => {
    return service.get("/bigdata/api/user/task/progress", { params })
  },
  // 查询大神分排行榜
  _get_god_score_rank: (params) => {
    return service.get("/user/v2/api/godScore/findRank", { params })
  },
  // 设置好友备注
  _set_friend_remark: (params) => {
    return service.post("/user/v2/api/friend/addRemarks", params)
  },
  //2025年度活动红包雨奖励
  _post_room_packet_award: (params) => {
    return service.post("/activity/api/hd/sd/klsj/getRoomKlsjPrize", params)
  },
  //2025年度活动红包雨信息
  _get_room_packet_info: (params) => {
    return service.get("/activity/api/hd/sd/klsj/getRoomKlsjInfo", { params })
  },
  //2025年度活动释放红包雨
  _get_room_release_packet: (params) => {
    return service.get("/activity/api/hd/cjhd/klsj/releaseRoomKlsj", { params })
  },
  //2025年度活动带带熊领奖
  _post_room_ddx_box: (params) => {
    return service.post("/activity/api/hd/sd/ddx/getRoomDdxPrize", params)
  },
  //2025年度活动助力熊信息
  _get_room_task_info: (params) => {
    return service.get("/activity/api/hd/sd/zl/findRoomZlInfo", {params})
  },
  // 获取客户端下载链接
  _get_client_download_sign: (params) => {
    return service.get("/config/api/download/getDownloadSign", { params })
  },
  // 查询包场状态
  _get_room_full_court_status: (params) => {
    return service.get("/live/api/room/package/v2/status", { params })
  },
  // 修改包场状态
  _post_room_full_court_status: (params) => {
    return service.post("/live/api/room/package/v2/set/status", params)
  },
  // 根据派单房类型可选列表
  _get_send_order_distribute: (params) => {
    return service.get("/config/api/category/distribute/room", { params })
  },
  // 获取禁言原因
  _get_room_dict_base: (params) => {
    return service.get("/liveV2/api/room/dict/base", { params })
  },
  // 查询房间禁言名单列表
  _get_room_banned_list: (params) => {
    return service.get("/liveV2/api/room/operation/banned/pageList", { params })
  },
  // 计算退款钻石
  _get_calculate_refund_diamond: (params) => {
    return service.get("/web/api/order/calculate/refundDiamond", { params })
  },
  // 添加黑名单
  _post_set_black_and_mute: (params) => {
    return service.post("/user/v2/api/relation/setBlackAndMute", params)
  },
  // 发送的图片
  _get_send_pic_list: (params) => {
    return service.get("/liveV2/api/room/kol/pic/list", { params })
  },
  // 素材库
  _get_send_pic_library: (params) => {
    return service.get("/liveV2/api/room/kol/pic/library", { params })
  },
  //删除图片素材
  _del_send_pic: (params) => {
    return service.post("/liveV2/api/room/kol/pic/remove", params)
  },
  //用户发送公屏图片
  _send_pic: (params) => {
    return service.get("/liveV2/api/room/kol/pic/send", { params })
  },
  //用户上传多张图片审核
  _upload_pic_save: (params) => {
    return service.post("/liveV2/api/room/kol/file/save", params)
  },
  // 开启麦位投屏
  _post_kol_mic_mirror_start: (params) => {
    return service.post("/liveV2/api/room/kol/mic/mirror/start", params)
  },
  // 结束麦位投屏
  _post_kol_mic_mirror_end: (params) => {
    return service.post("/liveV2/api/room/kol/mic/mirror/end", params)
  },
  // 副房间设置静音
  _post_kol_mic_mirror_mute: (params) => {
    return service.post("/liveV2/api/room/kol/mic/mirror/mute", params)
  },
  // 副房间取消静音
  _post_kol_mic_mirror_mute_cancel: (params) => {
    return service.post("/liveV2/api/room/kol/mic/mirror/mute/cancel", params)
  },
};
export default HTTP;
